import {
  differenceInHours,
  differenceInSeconds,
  format,
  isToday,
  isYesterday,
  parseISO,
} from "date-fns";
import { differenceInMinutes } from "date-fns/esm";
import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import DeleteModal from "../../../commonComponent/DeleteModal";
import ReactionButton from "./ReactionButton";
import { useAuth } from "../../../Context/AuthContext";
import {
  addReplyService,
  deleteCommentReplyService,
  deleteCommentService,
  getGroupPostsService,
  reactonComment,
} from "../../../services/GroupService";
import { showToastError, showToastSuccess } from "../../../Utils/Helper";
import { toastMsg } from "../../../Utils/AllConstant";
import ReactionIcons from "./ReactionIcons";
import "../style.css";


function CommentArea({ dt, selectedGroup, newComment, setNewComment, getGroupPosts }) {
  const auth = useAuth();
  const [postId, setPostId] = useState("");
  const [commentId, setCommentId] = useState("");
  //   const [newComment, setNewComment] = useState([]);
  const [visibleComment, setVisibleComment] = useState(2);
  const [isCommentClicked, setIsCommentClicked] = useState(false);
  const [openItem, setOpenItem] = useState("");
  const [isLoading, setLoader] = useState(false);
  const [CommentReaction, setCommentReaction] = useState({
    commentId: "",
    reaction: "",
  });
  const [replyId, setReplyId] = useState("");

  const [replyIndex, setReplyIndex] = useState("");

  const [toggleReply, setToggleReply] = useState(false);
  const [newReply, setNewReply] = useState("");

  const handleReplyShow = (id) => {
    setToggleReply(!toggleReply);
    setNewReply(id);
  };
  const deleteComment = async (postId, commentId) => {
    try {
      const response = await deleteCommentService(postId, commentId);
      if (response) {
        showToastSuccess(response?.data || "Comment deleted successfully.");
        getGroupPosts();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
      console.log(error);
    }
  };
  const deleteCommentReply = async (commentId, replyId) => {
    try {
      const response = await deleteCommentReplyService(commentId, replyId);
      if (response) {
        showToastSuccess(response?.data || "Reply deleted successfully.");
        getGroupPosts();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
      console.log(error);
    }
  };
  // const getGroupPosts = async () => {
  //   try {
  //     const response = await getGroupPostsService(selectedGroup._id);
  //     if (response) {

  //       setNewComment(
  //         response.filter((post) => post._id == dt._id)[0].comments
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // console.log(newComment);
  const addReply = async (commentID, reply) => {
    try {
      const response = await addReplyService({
        commentId: commentID,
        reply: reply,
      });
      if (response) {
        showToastSuccess(toastMsg.newReply);
        document.querySelector(`input[name='${commentID}']`).value = "";
        getGroupPosts();
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleReaction = (index) => {
    setOpenItem(openItem === index ? null : index);
  };
  const closeAllItems = () => {
    setOpenItem(null);
  };
  const handleCommentReply = (i) => {
    setIsCommentClicked(!isCommentClicked);
    setReplyIndex(i);
  };

  const handleReply = (e) => {
    // setIsCommentClicked(true)
    e.preventDefault();
    let reply = e.target.children[0].value;
    let commentID = e.target.children[0].name;
    let isValid = true;

    if (!reply) {
      isValid = false;
    }

    if (isValid && !isLoading) {
      setLoader(true);
      addReply(commentID, reply);
      setIsCommentClicked(false);
      getGroupPosts();
    }

    // console.log(commentID, reply);
  };

  const TotalLength = (x) => {
    let arr = Object.keys(x);
    let totallength = 0;
    arr.forEach((el) => {
      totallength += x[el].length;
    });
    return totallength;
  };
  const calT = (date) => {
    let hrs = differenceInHours(new Date(), parseISO(date));
    let min = differenceInMinutes(new Date(), parseISO(date));
    let sec = differenceInSeconds(new Date(), parseISO(date));

    if (hrs) return hrs + " hrs";
    else if (min) return min + " mins";
    else return sec + " secs";
  };
  const handleCommentShow = () => {
    if (visibleComment < newComment?.length) {
      setVisibleComment((prev) => prev + 2);
    } else {
      setVisibleComment(newComment?.length);
    }
  };
  const handleCommentReaction = async (e, id) => {
    const parms = {};
    parms["commentId"] = id;
    parms["reaction"] = e.target.name;
    parms["replyId"] = "";
    console.log(parms);
    console.log(e.target.name);
    try {
      const response = await reactonComment(parms);
      // console.log(response.status)
      if (response.status === 200) {
        // getForumsById();
        // setAskQuestion("");
        showToastSuccess("Reaction Added successfully");
        getGroupPosts();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const handleReplyReaction = async (e, id) => {
    const parms = {};
    parms["commentId"] = "";
    parms["reaction"] = e.target.name;
    parms["replyId"] = id;
    console.log(parms);
    console.log(e.target.name);
    try {
      const response = await reactonComment(parms);
      // console.log(response.status)
      if (response.status === 200) {
        // getForumsById();
        // setAskQuestion("");
        showToastSuccess("Reaction Added successfully");
        // setOpenItem(null);
        getGroupPosts();
        
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  return (
    <div className="ques-forum-comment px-2 mt-3 post" onClick={closeAllItems} style={{
      maxHeight:'300px',
      minHeight:'0px',
      overflowX:'hidden',
      overflowY:'scroll',
    }}>
      {/* start reply on comment................................................... */}
      {
        // toggleComment && newComment == state.selectedPost._id &&
        <div>
          {newComment && newComment?.slice(0, visibleComment).map((cm, index) => (
            <>
              <div key={cm._id}>
                <div className="d-flex align-items-center mt-4">
                  <div className="forum_ava me-3">
                    <img
                      src={cm?.profilePicture}
                      onError={(e) => {
                        e.target.src = "images/avatar.png";
                      }}
                      alt=""
                    />
                  </div>

                  <div className="col-md-10">
                    <p className="mb-0 fw-bold">{cm?.full_name}</p>
                  </div>
                  <div className="col-md-2">
                    {/* <span>
                                <FaEdit className="like_group mt-2 "></FaEdit>
                              </span> */}
                    {cm.userId === auth?.authUser?._id ? (
                      <span>
                        <FaTrash
                          className="like_group"
                          style={{ marginTop: "10px" }}
                          data-bs-toggle="modal"
                          data-bs-target="#deleteComment"
                          onClick={() => {
                            console.log(cm._id);
                            setPostId(dt._id);
                            setCommentId(cm._id);
                          }}
                        />
                      </span>
                    ) : null}
                    <DeleteModal
                      title={"Delete"}
                      content1={"Are you sure you want to delete"}
                      content2={"this comment?"}
                      modalId={"deleteComment"}
                      button2={"No"}
                      button1={"Yes"}
                      onDelete={() => deleteComment(postId, commentId)}
                    />
                  </div>
                </div>

                <div className="d-flex ps-3 column-gap-5 flex-column pe-3">
                  <p className="mb-3 ms-5">{cm.comment}</p>
                  <div className="d-flex justify-content-between align-items-center ques-foot fw-semibold">
                    <div className="ps-5 d-flex justify-content-between gap-2">
                      <p
                        className="pe-4 "
                        style={{
                          color: "rgba(73, 73, 73, 1)",
                          fontSize: "1em",
                        }}
                      >
                        {isYesterday(parseISO(cm.createdAt))
                          ? "Posted Yesterday"
                          : isToday(parseISO(cm.createdAt))
                          ? "Posted " + calT(cm.createdAt) + " ago"
                          : format(parseISO(cm.createdAt), "do MMM, yyyy")}
                      </p>
                      <p
                        className="pointer tipReaction pe-4"
                        style={{
                          color: "rgba(73, 73, 73, 1)",
                          fontSize: "1em",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReaction(index);
                        }}
                      >
                        React
                        {openItem === index && (
                          <ReactionIcons
                            onClick={(e) => handleCommentReaction(e, cm._id)}
                          />
                        )}
                      </p>
                      <p
                        className="pointer "
                        style={{
                          color: "rgba(73, 73, 73, 1)",
                          fontSize: "1em",
                        }}
                        onClick={() => handleCommentReply(index)}
                      >
                        Reply
                      </p>
                    </div>
                    {cm.likes && <ReactionButton cm={cm} />}
                  </div>

                  {isCommentClicked && index == replyIndex && (
                    <div className="row ps-5">
                      <div className="col-md-12">
                        <div className="btn-group activeforum_chat">
                          <form
                            onSubmit={(e) => handleReply(e)}
                            className="d-flex w-100"
                          >
                            <input
                              type="text"
                              name={cm._id}
                              placeholder="Type your reply here..."
                            />
                            <button type="submit">
                              <img src="images/arrow.png" alt="" />
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                  {cm?.repDetailedComments.length !== 0 && (
                    <div className="d-flex ms-5 ps-3 justify-content-start align-items-start">
                        <div style={{width:'10%'}}>
                        <hr style={{
                            height:`${toggleReply && newReply == cm._id ? "20px" : "0px"}`,
                            borderTop:'1px solid black',
                            borderLeft:'1px solid black'
                        }}>
                        </hr>
                        </div>
                      <div
                        onClick={() => handleReplyShow(cm._id)}
                        className=" ms-2 mt-1 cursor-pointer"
                        style={{ fontWeight: 500 }}
                      >
                        {toggleReply && newReply == cm._id
                          ? `Hide ${cm?.repDetailedComments.length} replies`
                          : `View ${cm?.repDetailedComments.length} replies`}
                      </div>
                    </div>
                  )}

                  {toggleReply && newReply == cm._id && (
                    <div id={`linux${cm?._id}`}>
                      {cm?.repDetailedComments.map((rep) => (
                        <div>
                          <div className="d-flex flex-column ps-3 justify-content-start ms-4  align-items-center">
                            {/* <div style={{ width: "5%" }}>
                            {" "}
                            <hr
                              style={{
                                borderTop: "1px solid black",
                              }}
                            />
                          </div> */}
                            <div className="d-flex w-100 justify-content-between ms-2">
                              <div className="d-flex align-items-center">
                                <div className="forum_ava me-3">
                                  <img
                                    src={rep?.profilePicture}
                                    onError={(e) => {
                                      e.target.src = "images/avatar.png";
                                    }}
                                    alt=""
                                  />
                                </div>
                                <span className="mb-0 fw-bold">{rep.name}</span>
                                {/* <span className="ms-2 text-secondary">
                                  {isYesterday(parseISO(rep?.createdAt))
                                    ? "Posted Yesterday"
                                    : isToday(parseISO(rep?.createdAt))
                                    ? "Posted " + calT(rep?.createdAt) + " ago"
                                    : format(
                                        parseISO(rep?.createdAt),
                                        "do MMM, yyyy"
                                      )}
                                </span> */}
                              </div>

                              <div className="ms-5 text-end">
                                {rep.userId === auth?.authUser?._id ? (
                                  <span
                                    onClick={() => {
                                      setCommentId(cm._id);
                                      setReplyId(rep._id);
                                    }}
                                  >
                                    <FaTrash
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteCommentReply"
                                      className="like_group"
                                      style={{
                                        marginTop: "10px",
                                      }}
                                    />
                                  </span>
                                ) : null}
                                <DeleteModal
                                  title={"Delete"}
                                  content1={"Are you sure you want to delete"}
                                  content2={"this reply?"}
                                  modalId={"deleteCommentReply"}
                                  button2={"No"}
                                  button1={"Yes"}
                                  onDelete={() =>
                                    deleteCommentReply(commentId, replyId)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ps-4 border-start mt-1 mb-3" style={{marginLeft:'66px'}}>
                            <span className="ms-3">
                              {rep?.commentReply}
                            </span>
                            <div className="ms-3 d-flex mt-3 justify-content-between align-items-start ques-foot fw-semibold">
                            <div className=" d-flex justify-content-between w-50">
                              <p
                                className="pe-4"
                                style={{
                                  color: "rgba(73, 73, 73, 1)",
                                  fontSize: "1em",
                                }}
                              >
                                {isYesterday(parseISO(rep.createdAt))
                                  ? "Posted Yesterday"
                                  : isToday(parseISO(rep.createdAt))
                                  ? "Posted " + calT(rep.createdAt) + " ago"
                                  : format(
                                      parseISO(rep.createdAt),
                                      "do MMM, yyyy"
                                    )}
                              </p>
                              <p
                                className="pointer tipReaction pe-4"
                                style={{
                                  color: "rgba(73, 73, 73, 1)",
                                  fontSize: "1em",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleReaction(rep._id);
                                }}
                              >
                                React
                                {openItem === rep._id && (
                                  <ReactionIcons
                                    onClick={(e) =>{
                                      // e.stopPropagation();
                                      handleReplyReaction(e, rep._id);
                                    }
                                    }
                                  />
                                )}
                              </p>
                              {/* <p
                                className="pointer "
                                style={{
                                  color: "rgba(73, 73, 73, 1)",
                                  fontSize: "1em",
                                }}
                                onClick={() => handleCommentReply(index)}
                              >
                                Reply
                              </p> */}
                            </div>
                            {rep.likes && <ReactionButton cm={rep} />}
                          </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </>
          ))}
          {visibleComment < newComment?.length ? (
            <div className="ms-2 my-2 d-flex justify-content-start align-items-center">
              <div
                    style={{
                      height: "1px",
                      backgroundColor: "black",
                      width: "10%"
                    }}
                  ></div>
              <div
                onClick={handleCommentShow}
                className=" ms-2  cursor-pointer"
                style={{ fontWeight: 500 }}
              >
                View more comments
              </div>
            </div>
          ) : (
            newComment?.length > 2 && (
              <div className="ms-2 my-2 d-flex justify-content-start align-items-center">
                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "black",
                      width: "10%"
                    }}
                  ></div>
                <div
                  onClick={() => setVisibleComment(2)}
                  className=" ms-2 cursor-pointer"
                  style={{ fontWeight: 500 }}
                >
                  View Less comments
                </div>
              </div>
            )
          )}
        </div>
      }

      {/* end reply on comment ................................................................ */}
    </div>
  );
}

export default CommentArea;
